import { IAttachment } from '../types'
import { allowedFileExtensions, MAX_FILE_SIZE_IN_MB } from '../constants'

interface IProps {
  extension: string
  size: number
  name: string
  totalFilesSize: number
  files: IAttachment[]
}

export const validateFile = (payload: IProps): void => {
  if (!allowedFileExtensions.some(ext => payload.extension === ext)) {
    throw new Error('invalidExtension')
  }
  if (payload.size > MAX_FILE_SIZE_IN_MB) {
    throw new Error('fileSizeLimit')
  }
  if (payload.totalFilesSize > MAX_FILE_SIZE_IN_MB) {
    throw new Error('totalFileSizeLimit')
  }
  const haveThisFile = payload?.files?.some(
    f =>
      payload.name === f.description + '.' + f.extension &&
      payload.size === f.size,
  )
  if (haveThisFile) {
    throw new Error('fileAlreadyAttached')
  }
}

export const convertBytesToMB = (bytes: number): number => {
  return bytes / 1024 / 1024
}

export const convertMBToBytes = (mb: number): number => {
  return mb * 1024 * 1024
}
